/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'account_number': 'IBAN',
    'account_owner': 'Kontoinhaber',
    'additional_address': 'Adresse hinzufügen',
    'additional_bank_details': 'Konto hinzufügen',
    'additional_email_address': 'E-Mail Adresse hinzufügen',
    'additional_phone': 'Telefonnummer hinzufügen',
    'address': 'Adresse',
    'address_line_1': 'Straße und Hausnummer',
    'address_line_2': 'Straße',
    'area': 'Bundesland',
    'bank_identifier': 'BIC',
    'bank_name': 'Bankname',
    'country': 'Land',
    'country_code': 'Ländercode',
    'dependent_locality': 'Zugehöriger Ort',
    'label': 'Label',
    'labels': {
      'business': 'Geschäftlich',
      'fax-business': 'Fax (geschäftlich)',
      'fax-private': 'Fax (privat)',
      'mobile-business': 'Mobil (geschäftlich)',
      'mobile-private': 'Mobil (privat)',
      'other': 'Sonstige',
      'personal': 'Privat'
    },
    'locale': 'Ort',
    'locality': 'Ort',
    'phone': 'Telefon',
    'postal_code': 'PLZ',
    'sorting_code': 'Sortierung'
  },

  /* english */
  en: {
    'account_number': 'IBAN',
    'account_owner': 'Account Owner',
    'additional_address': 'Add address',
    'additional_bank_details': 'Add account',
    'additional_email_address': 'Add email address',
    'additional_phone': 'Add phone number',
    'address': 'Address',
    'address_line_1': 'Street Address',
    'address_line_2': 'Address',
    'area': 'Area',
    'bank_identifier': 'BIC',
    'bank_name': 'Bank Name',
    'country': 'Country',
    'country_code': 'Country Code',
    'dependent_locality': 'Dependent Locality',
    'label': 'Label',
    'labels': {
      'business': 'Business',
      'fax-business': 'Fax (business)',
      'fax-private': 'Fax (private)',
      'mobile-business': 'Mobile (business)',
      'mobile-private': 'Mobile (private)',
      'other': 'Other',
      'personal': 'Private'
    },
    'locale': 'Locale',
    'locality': 'City',
    'phone': 'Phone',
    'postal_code': 'Postal Code',
    'sorting_code': 'Sorting Code'
  }
}
